import FirebaseUsage from "../firebase.usage";
import { COLLECTIONS } from "../constants";
import { DefaultSubscribeCallback } from "../../store/middleware/middlewares";
import MessageModel from "../../models/responses/message.model";

export class LedgerSubscriptions {
  static ledgerList(
    taskCode: string,
    contractId: string,
    callback: DefaultSubscribeCallback<MessageModel[]>
  ) {
    return FirebaseUsage.queryListenerWithOrder(COLLECTIONS.LEDGER_ENTRY, [
        ["contractId", "==", contractId],
        ["taskCode", "==", taskCode]], ["logTimestamp", "desc"], (data: any) =>
        callback(data.docs.map((d: any) => d.data() as MessageModel)));
  }

  static recentLedgerList(userId: string, contractId: string, callback: DefaultSubscribeCallback<MessageModel[]>) {
      return FirebaseUsage.getQueryWithOrderAndLimit(COLLECTIONS.LEDGER_ENTRY,
          [['contractId', '==', contractId],
          ['userId', '==', userId]],
          ['logTimestamp', 'desc'], 5)
            .then(data => {
                callback(data.docs.map(el => el.data() as MessageModel));
            });
  }
}
